import { Typography } from '@mui/material';
import React from 'react';

const Payment = () => {
    return (
        <div>
            <Typography variant="h4" className="title" style={{ fontWeight: 'bold' }}>Payment system is coming soon</Typography>
        </div>
    );
};

export default Payment;